export enum NotificationType {
  // Immediate : 1, // Not used anymore. Replaced with Mini notifications.
  Delayed = 2,
  Mini = 3,
}
